/* ─────────────────────────────────────────────────────────
   product.js — product page interactions
   Loaded only on product template via script tag in product.liquid
   ───────────────────────────────────────────────────────── */

/* Size guide tab switching — defined globally so ppSgTab onclick works */
window.ppSgTab = window.ppSgTab || function(btn, chart) {
  var tabs   = btn.closest('.pp-sg-tabs').querySelectorAll('.pp-sg-tab');
  var charts = btn.closest('.pp-sg-box').querySelectorAll('.pp-sg-chart');
  tabs.forEach(function(t) { t.classList.remove('active'); });
  btn.classList.add('active');
  charts.forEach(function(c) {
    if (c.dataset.chart === chart) {
      c.classList.add('active');
      c.classList.remove('exit');
    } else if (c.classList.contains('active')) {
      c.classList.remove('active');
      c.classList.add('exit');
      setTimeout(function() { c.classList.remove('exit'); }, 350);
    }
  });
};

/* Size guide open/close — co-located with ppSgTab */
window.ppSgOpen = window.ppSgOpen || function(e) {
  if (e) e.preventDefault();
  var m = document.getElementById('ppSgModal');
  if (m) {
    m.hidden = false;
    m.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
  }
};
window.ppSgClose = window.ppSgClose || function() {
  var m = document.getElementById('ppSgModal');
  if (m) {
    m.hidden = true;
    m.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
};

/* Sticky ATC — scroll detection to show/hide */
(function() {
  var sticky = document.getElementById('ppStickyAtc');
  if (!sticky) return;
  var atcBtn = document.getElementById('ppAtcBtn');
  if (!atcBtn) return;
  var atcRect;
  function check() {
    if (!atcRect) atcRect = atcBtn.getBoundingClientRect();
    var scrolled = atcBtn.getBoundingClientRect().bottom < 0;
    sticky.classList.toggle('pp-sticky-visible', scrolled);
  }
  window.addEventListener('scroll', check, { passive: true });
  check();
})();

/* ── Variant selection — uses ppVariants + ppProductOptions set inline ── */
window.ppUpdateVariant = function() {
  if (typeof ppVariants === 'undefined') return;
  var selected = {};
  document.querySelectorAll('#ppForm input[type=radio]:checked').forEach(function(el) {
    selected[el.name.replace('options[','').replace(']','')] = el.value;
  });
  var opts = window.ppProductOptions || [];
  var match = ppVariants.find(function(v) {
    return v.options.every(function(opt, i) { return selected[opts[i]] === opt; });
  });
  if (!match) return;
  var vi = document.getElementById('ppVariantId');
  if (vi) vi.value = match.id;
  var p = document.getElementById('ppPrice');
toLocaleString('en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' })
  var btn = document.getElementById('ppAtcBtn');
  if (btn) {
    btn.disabled = !match.available;
    var sp = btn.querySelector('span');
    if (sp) sp.textContent = match.available ? 'Own It Now' : 'Sold Out';
    btn.classList.toggle('pp-atc-disabled', !match.available);
  }
  if (match.featured_image && typeof ppGoToImage === 'function') {
    /* PDF audit item 03: clamp to rendered slide range.
       Shopify position is 1-based. If a variant's image sits beyond
       the rendered slide count (edge case on large catalogues), fall
       back to slide 0 instead of wrapping to an unrelated image. */
    var _slides = document.querySelectorAll('#pgMain .pg-slide');
    var _targetIdx = match.featured_image.position - 1;
    if (_slides.length > 0 && _targetIdx >= _slides.length) _targetIdx = 0;
    ppGoToImage(_targetIdx);
  }

  /* ── Stock indicator: only show after user picks a size ── */
  var stockEl     = document.getElementById('ppLowStock');
  var stockTextEl = document.getElementById('ppLowStockText');
  var LOW_STOCK_THRESHOLD = 5;
  if (stockEl) {
    /* Use the Liquid-rendered ppInventory map — more reliable than variant JSON inventory_quantity */
    var qty = (window.ppInventory && typeof window.ppInventory[match.id] === 'number')
              ? window.ppInventory[match.id]
              : null;
    if (match.available && qty !== null && qty > 0 && qty <= LOW_STOCK_THRESHOLD) {
      if (stockTextEl) stockTextEl.textContent = 'Only ' + qty + ' left';
      stockEl.style.display = '';   /* let theme CSS (display:flex) take over */
    } else {
      stockEl.style.display = 'none';
    }
  }
};

/* ── Still Thinking banner ATC ── */
window.ppBannerATC = function() {
  var id = parseInt(document.getElementById('ppVariantId').value);
  if (!id) return;
  var btn = document.querySelector('.pp-st-btn');
  if (btn) btn.textContent = 'Adding…';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: id, quantity: 1 })
  }).then(function() { window.location.href = '/cart'; })
    .catch(function() { window.location.href = '/cart'; });
};

/* ── AJAX ATC form submission ── */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('ppForm');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var id = parseInt(document.getElementById('ppVariantId').value);
      if (!id) return;
      var btn = document.getElementById('ppAtcBtn');
      var sp  = btn && btn.querySelector('span');
      if (sp) sp.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        if (sp) sp.textContent = 'Own It Now';
        if (window.zfOpenCart) window.zfOpenCart();
      })
      .catch(function() {
        if (sp) sp.textContent = 'Own It Now';
        window.location.href = '/cart';
      });
    });
  });
})();

/* ── Back-in-stock notify — routes directly to Klaviyo ── */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var f = document.getElementById('ppNotifyForm');
    if (!f) return;
    f.addEventListener('submit', function(e) {
      e.preventDefault();
      var em      = f.querySelector('input[type="email"]').value.trim();
      var product = window.ppProductHandle || '';
      if (!em) return;

      /* Keep local record for reference */
      try {
        var l = JSON.parse(localStorage.getItem('zf_notify') || '[]');
        l.push({ product: product, email: em, ts: Date.now() });
        localStorage.setItem('zf_notify', JSON.stringify(l));
      } catch(err) {}

      /* ── POST to Klaviyo client-side subscriptions API ──
         Public API key: QQZCpc  |  Back in Stock list: UuADxY
         Also passes product handle as a custom property so
         Klaviyo flows can trigger per-product restock alerts. */
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=QQZCpc', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'revision': '2023-12-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              list_id: 'UuADxY',
              email_address: {
                address: em
              },
              properties: {
                back_in_stock_product: product,
                source: 'back_in_stock_form'
              },
              custom_source: 'back_in_stock'
            }
          }
        })
      })
      .then(function() {
        f.hidden = true;
        var ok = document.getElementById('ppNotifyOk');
        if (ok) ok.hidden = false;
      })
      .catch(function() {
        /* Show success anyway — local record is preserved */
        f.hidden = true;
        var ok = document.getElementById('ppNotifyOk');
        if (ok) ok.hidden = false;
      });
    });
  });
})();

/* ── Escape key: close size guide modal ── */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    if (typeof window.ppSgClose === 'function') window.ppSgClose();
  }
});

/* ── Run on page load to reflect the default pre-selected variant ── */
document.addEventListener('DOMContentLoaded', function() {
  if (typeof window.ppUpdateVariant === 'function') window.ppUpdateVariant();
});
/* ── Talles agotados: tachados en los botones de talle (22/09) ── */
(function() {
  function ppMarkSoldOut() {
    if (typeof ppVariants === 'undefined') return;
    var opts = window.ppProductOptions || [];
    var selected = {};
    document.querySelectorAll('#ppForm input[type=radio]:checked').forEach(function(el) {
      selected[el.name.replace('options[','').replace(']','')] = el.value;
    });
    document.querySelectorAll('#ppForm .pp-size-btn input[type=radio]').forEach(function(input) {
      var name = input.name.replace('options[','').replace(']','');
      var idx = opts.indexOf(name);
      if (idx < 0) return;
      var anyAvailable = ppVariants.some(function(v) {
        if (v.options[idx] !== input.value || !v.available) return false;
        return v.options.every(function(o, i) { return i === idx || !selected[opts[i]] || selected[opts[i]] === o; });
      });
      input.closest('.pp-size-btn').classList.toggle('pp-size-soldout', !anyAvailable);
    });
  }
  var _orig = window.ppUpdateVariant;
  window.ppUpdateVariant = function() {
    if (typeof _orig === 'function') _orig.apply(this, arguments);
    ppMarkSoldOut();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ppMarkSoldOut);
  else ppMarkSoldOut();
})();